import React from 'react';
import PropTypes from "prop-types";

const Intro = ({ data }) => {
    return (
        <div className="intro-section overlay section" style={{
            backgroundImage: data.type === 'image' ? `url(${process.env.PUBLIC_URL + data.backgroundImage})` : 'none',
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            height: '100vh' // 确保容器占满整个视口高度
        }}>
            {data.type === 'video' && (
                <video className="intro-video" autoPlay loop muted playsInline style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: -1
                }}>
                    <source src={process.env.PUBLIC_URL + data.backgroundImage} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            )}
            <div className="container">
                <div className="row row-cols-lg-1 row-cols-1">
                    <div className="col align-self-center">
                        <div className="intro-content mt-xl-8 mt-lg-8 mt-md-8 mt-sm-8 mt-xs-8">
                            <h2 className="title">{data.title}<br/><span className=''>({data.head})</span></h2>
                            <h2 className="date-and-locate">{data.date}<br/>{data.locate}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Intro.propTypes = {
    data: PropTypes.object
};

export default Intro;
